import styled from '@emotion/styled'

type SectionProps = {
  title: string
  children: React.ReactNode
}

const SectionTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 15px;
`

export const Section = ({ title, children }: SectionProps) => {
  return (
    <div>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </div>
  )
}
